export const ORG_ADMIN_ONLY_TOOLTIP =
  'Only organization admins can change these settings.';

export type OrgRole = 'admin' | 'member';

/** Normalize `orgRole` from Firebase ID token custom claims (via `getIdTokenResult().claims`). */
export function orgRoleFromIdTokenClaims(
  claims: Record<string, unknown> | undefined | null,
): OrgRole {
  const raw = claims?.orgRole;
  const r = typeof raw === 'string' ? raw.toLowerCase() : '';
  if (r === 'admin') return 'admin';
  return 'member';
}
